export const CHART_TYPES = {
  bar: 'bar',
  hBar: 'hBar',
  line: 'line',
  pie: 'pie',
  doughnut: 'doughnut',
  area: 'area',
  bubble: 'bubble',
  polarArea: 'polarArea',
  radar: 'radar'
};
export const CHARTS_LIST = Object.entries(CHART_TYPES).map(_ref => {
  let [key, value] = _ref;
  return value;
});
export const NOT_CHART_TYPES = {
  map: 'map',
  kpi: 'kpi',
  table: 'table'
};
export const NOT_CHARTS_LIST = Object.entries(NOT_CHART_TYPES).map(_ref2 => {
  let [key, value] = _ref2;
  return value;
});
export const EXPANDED_TABS = {
  chart: 'chart',
  table: 'table'
};
export const BASE_LAYOUT_SPECS = {
  w: 1,
  h: 7,
  minW: 1,
  // mínimo número de columnas que el widget puede ocupar
  minH: 7,
  // mínimo número de filas que el widget puede ocupar
  moded: false,
  static: false
};
export const FORCE_BI_SUBMODULE = 'forceBI';